// Not a credential. A local sign-out/auth-failure latch prevents silently adopting
// an unrelated HTTP-only cookie after the explicit bearer context is discarded.
const KEY='washpros_auth_explicit_exit';
let blocked=false;
export function automaticCookieRestoreBlocked({ explicitToken = false } = {}) {
  if (blocked) return true;
  try { return blocked || localStorage.getItem(KEY)==='1'; }
  catch { return !explicitToken; } // Only an explicit token may work without readable cookie-exit state.
}
export function blockAutomaticCookieRestore() {
  blocked=true;
  try {localStorage.setItem(KEY,'1');} catch { /* in-memory latch still protects this page */ }
}
export function allowExplicitLogin() {
  blocked=false;
  try {localStorage.removeItem(KEY);} catch { /* a fresh explicit token remains authoritative */ }
}
export function restoredIdentityMatches(cached,verified) {
  if (!cached) return true;
  try {
    const previous=typeof cached==='string'?JSON.parse(cached):cached;
    return !previous?.user_id || previous.user_id===verified?.user_id;
  } catch { return false; }
}